import React from "react";
import {
  FoldersIndex
} from "../../_metronic/_partials";

export function FoldersPage() {
  return <FoldersIndex />;
}
